/* eslint-disable react-hooks/exhaustive-deps */
import {
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Image,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
} from "react-bootstrap";
import {
    BsArrowDown,
    BsArrowRight,
    BsCalendar,
    BsCurrencyDollar,
    BsLayoutThreeColumns,
    BsPrinter,
    BsReceipt,
    BsShield,
    BsVr,
    BsWallet2,
} from "react-icons/bs";
import { FaCopy } from "react-icons/fa6";
import { IoReceiptOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";

import { GrStatusInfo } from "react-icons/gr";
import { HiOutlineTicket } from "react-icons/hi";
import img from "assets/img/bg/01.jpg";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useApiClient from "hooks/useApiClient";
import useToggle from "hooks/useToggle";
import { getPassengersNumbers } from "helpers/flightHelper";
import { formatPrice } from "helpers/common";
import { square } from 'ldrs'
import { useTranslation } from "react-i18next";
square.register()

const ConfirmTicket = () => {
    const { api, urls } = useApiClient();
    const [searchParams] = useSearchParams();
    const [data, setData] = useState(null);
    const orderNumber = searchParams.get("orderNumber");
    const [loading, setLoading] = useState(false);
    const [eticketEmail, setEticketEmail] = useState("");
    const [eticketEmailError, setEticketEmailError] = useState("");
    const { isOpen, toggle } = useToggle();
    const [isShaking, setIsShaking] = useState(false);
    const [emailType, setEmailType] = useState("");
    const { t } = useTranslation()


    const fetchOrder = useCallback(() => {
        if (!orderNumber) return;
        setLoading(true);
        const queryParams = new URLSearchParams();
        queryParams.append("orderNumber", orderNumber);
        const requestUrl = `${urls.flight.order}?${queryParams}`;
        api.get(requestUrl)
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [api, orderNumber, urls.flight.order]);

    useEffect(() => {
        fetchOrder();
    }, []);

    if (loading) {
        return (
            <div
                className="w-100   d-flex  justify-content-center align-items-center"
                style={{ height: "60dvh" }}
            >
                <l-square
                    size="40"
                    stroke="3.5"
                    speed="1"
                    color="#000000"
                ></l-square>
            </div>
        );
    }

    if (!data) {
        return (
            <section className="pt-4 ">
                <Container>
                    <Row>
                        <Col md={10} xl={10} className="mx-auto">
                            <Card
                                className="shadow"
                                style={{ height: "60dvh" }}
                            >
                                <CardBody className="text-center p-4 d-flex flex-column align-items-center justify-content-center">
                                    <h1
                                        className="card-title fs-3"
                                        style={{ color: "red" }}
                                    >
                                        No booking found !
                                    </h1>
                                    <h5> check your email</h5>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }

    const { nrOfAdult, nrOfChild, nrOfInfant } = getPassengersNumbers(
        data?.booking?.price?.breakdown
    );
    const logoSrc = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${data?.booking?.bounds[0]?.segments[0].marketingCompany}.png`;

    const handlePrintEticket = () => {
        const queryParams = new URLSearchParams();
        queryParams.append("id", data?.bookingKey);
        queryParams.append(
            "token",
            JSON.parse(localStorage.getItem("user-session") || "{}")?.session
                ?.token ||
                "kdNM6bfO71nSckWUApaVjuo9K1Dmy4jrq9kHJ7SYVnTuLxHmakBNhyYTLVNl"
        );
        const requestUrl = `${process.env.REACT_APP_SERVER_URL}${urls.flight.eticket}?${queryParams}`;
        window.open(requestUrl, "_blank");
    };
    const handlePrintReceipt = () => {
        const queryParams = new URLSearchParams();
        queryParams.append("id", data?.bookingKey);
        queryParams.append(
            "token",
            JSON.parse(localStorage.getItem("user-session") || "{}")?.session
                ?.token ||
                "kdNM6bfO71nSckWUApaVjuo9K1Dmy4jrq9kHJ7SYVnTuLxHmakBNhyYTLVNl"
        );
        const requestUrl = `${process.env.REACT_APP_SERVER_URL}${urls.flight.receipt}?${queryParams}`;
        window.open(requestUrl, "_blank");
    };
    const validateEticketEmail = (e) => {
        const email = e.target.value;
        setEticketEmail(email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (!email) {
            setEticketEmailError("Email is required.");
        } else if (!emailRegex.test(email)) {
            setEticketEmailError("Please enter a valid email address.");
        } else {
            setEticketEmailError("");
        }
    };
    const handleSendEmailEticket = (e) => {
        e.preventDefault();
        if (eticketEmailError === "") {
            const queryParams = new URLSearchParams();
            queryParams.append("email", eticketEmail);
            setEticketEmail("");
            queryParams.append("id", data?.bookingKey);
            let requestUrl = "";
            if (emailType === "reciept") {
                requestUrl = `${urls.flight.receiptEmail}?${queryParams}`;
            } else if (emailType === "e-ticket") {
                requestUrl = `${urls.flight.eticketEmail}?${queryParams}`;
            }
            api.get(requestUrl)
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    toggle();
                });
        } else {
            shakeAnimation();
        }
    };

    const shakeAnimation = () => {
        setIsShaking(true);
        setTimeout(() => {
            setIsShaking(false);
        }, 2000);
    };

    const copyToClipboard = () => {
        const url = window.location.href;
        navigator.clipboard
            .writeText(url)
            .then(() => {
                alert("URL copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <section className="pt-4">
            <Container>
                <Row>
                    <Col md={10} xl={10} className="mx-auto">
                        <Card className="shadow">
                            <Image
                                src={img}
                                className="rounded-top"
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "cover",
                                }}
                            />
                            <CardBody className="text-center p-4">
                                <h1 className="card-title fs-3 text-success">
                                    {data?.booking?.status === "CONFIRMED" &&
                                       t("bookingConfirmed")}
                                    {data?.booking?.status === "CANCELLED" &&
                                       t("bookingCancelled")}
                                    {data?.booking?.status === "PENDING" &&
                                        t("bookingPending")}
                                </h1>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "20px" }}
                                        ></div>
                                    </Col>
                                </Row>

                                <Row className="justify-content-between text-start mb-4">
                                    <Col lg={12}>
                                        <ul className="list-group list-group-borderless">
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsVr className=" fa-fw me-2" />
                                                    {t("transactionId")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment?.oderId}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsReceipt className=" fa-fw me-2" />
                                                    {t("orderNumber")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment?.OrderNumber}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsShield className=" fa-fw me-2" />
                                                    {t("authorizationNumber")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {
                                                        data?.payment
                                                            ?.approvalCode
                                                    }
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsArrowDown className=" fa-fw me-2" />
                                                    {t("response")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0 success-text">
                                                    {data?.payment?.params?.respCode_desc || "Paiement a été accepté"}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsWallet2 className=" fa-fw me-2" />
                                                    {t("paymentMethod")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    Carte Bancaire CIB/DAHABIA
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsLayoutThreeColumns className=" fa-fw me-2" />
                                                    {t("reference")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.booking?.pnr}{" "}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <GrStatusInfo className=" fa-fw me-2" />
                                                    {t("status")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0 success-text">
                                                    {data?.booking?.status}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsCalendar className=" fa-fw me-2" />
                                                    {t("validate")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment?.timestamp}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="flex gap-1 items-center">
                                                    <BsCurrencyDollar className=" fa-fw me-2" />
                                                    {t("totalPrice")}:
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {formatPrice(
                                                        data?.booking?.price
                                                            ?.total
                                                    )}
                                                </span>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table className="table align-middle p-4 mb-0 table-hover">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-start"
                                                        >
                                                            Passenger
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            Type
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            Status
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-end"
                                                        >
                                                            Ticket Number
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.booking.ticketNumbers.map(
                                                        (passenger, indx) => {
                                                            return (
                                                                <tr key={indx}>
                                                                    <td>
                                                                        {" "}
                                                                        {
                                                                            passenger.lastname
                                                                        }{" "}
                                                                        {
                                                                            passenger.firstname
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            passenger.type
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            className="success-text"
                                                                            style={{
                                                                                fontWeight:
                                                                                    "bold",
                                                                            }}
                                                                        >
                                                                            {
                                                                                passenger.status
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            passenger.ticket
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "40px" }}
                                        ></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table className="table align-middle p-4 mb-0 table-hover">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-start"
                                                        >
                                                            Airports
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            Type
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-end"
                                                        >
                                                            Luggage
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {nrOfAdult !== 0 && (
                                                        <>
                                                            {data.booking.price.breakdown.ADT.baggageAllowance.map(
                                                                (
                                                                    bagg,
                                                                    indx
                                                                ) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                indx
                                                                            }
                                                                        >
                                                                            <td></td>
                                                                            <td>
                                                                                ADT
                                                                            </td>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight:
                                                                                            "bold",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        bagg
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </>
                                                    )}
                                                    {nrOfChild !== 0 && (
                                                        <>
                                                            {data.booking.price.breakdown.CHD.baggageAllowance.map(
                                                                (
                                                                    bagg,
                                                                    indx
                                                                ) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                indx
                                                                            }
                                                                        >
                                                                            <td></td>
                                                                            <td>
                                                                                CHD
                                                                            </td>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight:
                                                                                            "bold",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        bagg
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </>
                                                    )}
                                                    {nrOfInfant !== 0 && (
                                                        <>
                                                            {data.booking.price.breakdown.INF.baggageAllowance.map(
                                                                (
                                                                    bagg,
                                                                    indx
                                                                ) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                indx
                                                                            }
                                                                        >
                                                                            <td></td>
                                                                            <td>
                                                                                INF
                                                                            </td>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight:
                                                                                            "bold",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        bagg
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "40px" }}
                                        ></div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={12} className="title">
                                        <h6>
                                            From {data.booking.bounds[0].origin}{" "}
                                            to{" "}
                                            {data.booking.bounds[0].destination}
                                        </h6>
                                    </Col>
                                </Row>
                                {data.booking.bounds[0].segments.map(
                                    (segment, index) => {
                                        return (
                                            <Row key={index}>
                                                <Col
                                                    lg={2}
                                                    className="flex flex-col items-center justify-center gap-2"
                                                >
                                                    <img
                                                        alt={`Logo `}
                                                        src={logoSrc}
                                                    ></img>
                                                    <span
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {
                                                            segment.marketingCompany
                                                        }
                                                    </span>
                                                </Col>
                                                <Col lg={3}>
                                                    <span
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {
                                                            segment.originDestination
                                                        }
                                                    </span>
                                                    <br></br>
                                                    <span>
                                                        {segment.departureDate}{" "}
                                                        at{" "}
                                                        {segment.departureTime}
                                                    </span>
                                                </Col>
                                                <Col
                                                    lg={1}
                                                    style={{
                                                        marginTop: "20px",
                                                    }}
                                                >
                                                    <BsArrowRight></BsArrowRight>
                                                </Col>
                                                <Col lg={3}>
                                                    <span
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {
                                                            segment.arrivalDestination
                                                        }
                                                    </span>
                                                    <br></br>
                                                    <span>
                                                        {segment.arrivalDate} at{" "}
                                                        {segment.arrivalTime}
                                                    </span>
                                                </Col>
                                                <Col
                                                    lg={3}
                                                    style={{
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    Class{" "}
                                                    <span
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {segment.bookingClass}
                                                    </span>
                                                    <br></br>
                                                    Flight{" "}
                                                    <span
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {segment.flightNumber}
                                                    </span>
                                                </Col>
                                            </Row>
                                        );
                                    }
                                )}

                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "30px" }}
                                        ></div>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-row-reverse w-auto gap-2 gap-md-0 ">
                                    <Dropdown className="me-sm-2 mb-2 mb-sm-0">
                                        <DropdownToggle
                                            as="button"
                                            type="button"
                                            className="arrow-none btn btn-primary mb-0 w-100 flex items-center gap-1"
                                            role="button"
                                        >
                                            <IoReceiptOutline className=" me-2" />
                                            Receipt
                                        </DropdownToggle>
                                        <DropdownMenu
                                            align="end"
                                            className="min-w-auto shadow rounded"
                                        >
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={() => {
                                                        handlePrintReceipt();
                                                    }}
                                                >
                                                    <BsPrinter className="me-2" />
                                                    Print
                                                </DropdownItem>
                                            </li>
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={() => {
                                                        handlePrintReceipt();
                                                    }}
                                                >
                                                    <FiDownload className="me-2" />
                                                    Download
                                                </DropdownItem>
                                            </li>
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        toggle();
                                                        setEmailType("reciept");
                                                    }}
                                                >
                                                    <MdOutlineEmail className="me-2" />
                                                    Email
                                                </DropdownItem>
                                            </li>
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={() => {
                                                        copyToClipboard();
                                                    }}
                                                >
                                                    <FaCopy className="me-2" />
                                                    Copy link
                                                </DropdownItem>
                                            </li>
                                        </DropdownMenu>
                                    </Dropdown>
                                    <Dropdown className="me-sm-2 mb-2 mb-sm-0">
                                        <DropdownToggle
                                            as="button"
                                            type="button"
                                            className="arrow-none btn btn-success mb-0 w-100 flex items-center gap-1"
                                            role="button"
                                        >
                                            <HiOutlineTicket className=" me-2" />
                                            E-ticket
                                        </DropdownToggle>
                                        <DropdownMenu
                                            align="end"
                                            className="min-w-auto shadow rounded"
                                        >
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={() =>
                                                        handlePrintEticket()
                                                    }
                                                >
                                                    <BsPrinter className="me-2" />
                                                    Print
                                                </DropdownItem>
                                            </li>
                                            <li>
                                                <DropdownItem
                                                    className="items-center"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        toggle();
                                                        setEmailType(
                                                            "e-ticket"
                                                        );
                                                    }}
                                                >
                                                    <MdOutlineEmail className="me-2" />
                                                    Email
                                                </DropdownItem>
                                            </li>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal
                show={isOpen}
                onHide={toggle}
                size="lg"
                className="fade"
                id="cancellation"
                aria-hidden="true"
            >
                <ModalHeader>
                    <h5 className="modal-title">Send E-ticket by email</h5>
                    <button
                        type="button"
                        onClick={toggle}
                        className="btn-close"
                    />
                </ModalHeader>
                <ModalBody className="p-3">
                    <h6 className="text-center">
                        Please enter your email below{" "}
                        <span className="text-danger">*</span>
                    </h6>
                    <Row className="g-3 justify-content-center m-4 mb-0">
                        <input
                            className={`form-control border-primary ${
                                eticketEmailError !== "" && "border-danger"
                            }`}
                            type="email"
                            placeholder="Enter your email..."
                            aria-label="email"
                            onChange={(e) => {
                                validateEticketEmail(e);
                            }}
                            value={eticketEmail}
                        />
                        {eticketEmailError !== "" ? (
                            <div
                                className={`mt-0 mb-0 text-danger ${
                                    isShaking ? "shake" : ""
                                } `}
                            >
                                {eticketEmailError}
                            </div>
                        ) : (
                            <div className="mb-2"></div>
                        )}
                    </Row>
                    <Row className="g-3 justify-content-start "></Row>
                    <Row className="g-3 justify-content-center m-4">
                        <Col xs={6} sm={4}>
                            <button
                                onClick={toggle}
                                className="btn btn-outline-danger w-100"
                            >
                                Cancel
                            </button>
                        </Col>
                        <Col xs={6} sm={4}>
                            <button
                                disabled={loading}
                                onClick={(e) => {
                                    handleSendEmailEticket(e);
                                }}
                                className={`btn btn-primary w-100 `}
                            >
                                Send
                            </button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </section>
    );
};

export default ConfirmTicket;
